import { Database } from "@punchup/data/supabase.types";
import { SupabaseClient } from "@supabase/supabase-js";
import { getSubscriptionPriceForComedian } from "@/data/subscriptions";
import { useQuery } from "@tanstack/react-query";

export default function useSubscriptionPriceForComedian(
  supabase: SupabaseClient<Database>,
  comedianId: string
) {
  const {
    data: subscriptionPrice,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["subscriptionPrice", comedianId],
    queryFn: () => getSubscriptionPriceForComedian(supabase, comedianId),
    staleTime: 1000 * 60 * 60, // 60 minutes
    enabled: !!comedianId,
  });

  return { subscriptionPrice, isLoading, error };
}
